import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/shared/user.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { PermissionLevel } from '../../permission/enums/permissionLevel.enum';
import { NoPermissionAction } from '../../shared/directives/check-permissions.directive';

@Component({
  selector: 'terra-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss', '../account.component.scss']
})
export class MyAccountComponent implements OnInit {
  paths = TerraUtils.consts.paths;
  private readonly userService = inject(UserService);
  private readonly titleService = inject(Title);

  userDetails$ = this.userService.accountDetails$;
  supportPin$ = this.userService.supportPin$;

  PermissionLevel = PermissionLevel;
  NoPermissionAction = NoPermissionAction;

  ngOnInit() {
    this.titleService.setTitle('My Account' + TerraUtils.consts.GpPageTitleSuffix);
  }
}
